import Vue from 'vue'
import axios from 'axios'
import stickyJs from 'sticky-js'
import BreakoutTracks from './components/BreakoutTracks.vue'
import Faqitem from './components/FaqItem.vue'
import OrangeLogo from '../images/orange-logo.svg'
import Speakers from './components/Speakers.vue'
import Timeslots from './components/Timeslots.vue'
import Modal from './components/Modal.vue'
import Schedule from './components/Schedule.vue'

window.Vue = Vue;

var app = new Vue({
    el: '#page-container',
    components: {
        BreakoutTracks,
        Faqitem,
        OrangeLogo,
        Timeslots,
        Speakers,
        Modal,
        Schedule
    },

    data: function() {
        return {
            breakoutTracks: null,
            timeslots: [],
            sessions: null,
            speakers: null,
            showModal: false,
            currentModalComponent: null,
            modalArguments: null,
            currentDay: null
        }
    },

    created: function() {
        console.log('Orange Conference 2018');
        var self = this;

        var sticky = new stickyJs('.sticky', {
            wrap: true,
            stickyClass: 'sticky--stick'
        });

        // Get Breakout Tracks
        axios.get('https://api.rethinkgroup.org/attendeeApp/api/v1/?action=getCategories&eventID=' + window.oc_event_id, {
        }).then(function(response) {
            self.breakoutTracks = response.data.categories;

        });

        // Get Sessions
        axios.get('https://api.rethinkgroup.org/attendeeApp/api/v1/?action=getSessions&eventID=' + window.oc_event_id, {
        }).then(function(response) {
            self.sessions = response.data.sessions;
            var timeslotNames = [];

            for(var i = 0; i < self.sessions.length; i++) {
                if(timeslotNames.indexOf(self.sessions[i]['eventSessionTimeSlot']) === -1 && self.sessions[i]['eventSessionTimeSlot']) {

                    timeslotNames.push(self.sessions[i]['eventSessionTimeSlot']);

                    var type = 'breakout';
                    if(self.sessions[i].eventSessionTimeSlot.indexOf('Workshop') != -1) {
                        type = 'workshop';
                    }

                    self.timeslots.push({
                        name: self.sessions[i]['eventSessionTimeSlot'],
                        type: type,
                        startTime: self.sessions[i]['eventSessionStartDT'],
                        endTime: self.sessions[i]['eventSessionEndDT']
                    });
                }
            }
        });

        // Get Speakers
        axios.get('https://api.rethinkgroup.org/attendeeApp/api/v1/?action=getSpeakersWebContent&eventID=' + window.oc_event_id, {
        }).then(function(response) {
            self.speakers = response.data.qa;
        });

    },

    methods: {
        openModal: function(event) {
            var el = event.target;

            this.currentModalComponent = el.getAttribute('data-modal');
            this.modalArguments = el.dataset;
            this.showModal = true;
            //window.onscroll = function () { window.scrollTo(0, 0); };
            document.body.classList.add("modal-open");
        },

        closeModal: function() {
            this.showModal = false;
            this.currentModalComponent = null;
            document.body.classList.remove("modal-open");
        },

        showDate: function(dayRef) {
            this.currentDay = dayRef;
        }
    }
});


// WEBPACK FOOTER //
// ./source/js/main.js